import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Bell, MapPin, Phone } from "lucide-react";

export default function AgencySosList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/agency/sos-signals").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <AdminLayout>
      <div className="haruki-fade-in">
        <h1 className="font-heading text-3xl font-bold">SOS Signals</h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          You see <strong>timestamp + geo resources</strong> only. Never the conversation content, never which individual triggered it.
          Use this to staff aggregate peer-support response — not to investigate individuals.
        </p>

        <div className="mt-8 space-y-3">
          {items.map(s => (
            <Card key={s.signal_id} data-testid={`sos-row-${s.signal_id}`}>
              <CardContent className="flex items-center justify-between gap-4 p-5">
                <div className="flex items-center gap-3">
                  <Bell className="h-5 w-5" style={{ color: "hsl(var(--haruki-teal))" }} />
                  <div>
                    <div className="font-heading text-sm font-semibold">SOS session opened</div>
                    <div className="text-xs text-muted-foreground">{s.triggered_at}</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  {s.geo_resources?.lat != null && (
                    <span className="flex items-center gap-1">
                      <MapPin className="h-3 w-3" />
                      {Number(s.geo_resources.lat).toFixed(2)}, {Number(s.geo_resources.lng).toFixed(2)}
                    </span>
                  )}
                  {s.geo_resources?.region && <span>{s.geo_resources.region}</span>}
                  {s.geo_resources?.eap_phone && (
                    <span className="flex items-center gap-1"><Phone className="h-3 w-3" /> {s.geo_resources.eap_phone}</span>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
          {items.length === 0 && (
            <Card><CardContent className="p-6 text-sm text-muted-foreground">No SOS signals — none received from your agency.</CardContent></Card>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
